var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-height-normal inline-flex items-center rounded px-1 text-sm",class:{
    'bg-WineSparkling': _vm.color === 'WineSparkling',
    'bg-WineWhite ': _vm.color === 'WineWhite',
    'border border-WineOrganic text-WineOrganic ': _vm.color === 'WineOrganic',
    'border border-WineSweet text-WineSweet ': _vm.color === 'WineSweet',
    'bg-WineRed ': _vm.color === 'WineRed',
    'bg-WineRose': _vm.color === 'WineRose',
    'bg-WineOrange ': _vm.color === 'WineOrange',
    'bg-Black88': _vm.color === 'WineMix',
    'bg-SaleRed': _vm.color == 'Sale',
    'bg-Gold': _vm.color == 'Gold',
    'bg-Gray': _vm.color == 'Gray',
    'bg-LightGray': _vm.color == 'LightGray',
    'bg-Black06': _vm.color == 'DarkGold',
    'font-yumincho': _vm.color == 'DarkGold',

    'text-Black40': _vm.color == 'Gray',
    'text-Black60': _vm.color == 'Black',
    'text-DarkGold': _vm.color == 'DarkGold',
    'text-White': _vm.color && _vm.color !== 'DarkGold',

    'border border-WineRed bg-White text-WineRed': _vm.outline === 'Red',
    'bg-Black10 text-WineRed': _vm.outline === 'VintageRed',
    'border border-Black10 bg-White text-Black80': _vm.outline === 'Gray',
    'border border-SaleRed bg-White text-SaleRed': _vm.outline === 'Sale',
    'border border-Black06 bg-White text-Black60': _vm.outline === 'LightGray',
    'border border-Black60 bg-White text-Black60': _vm.outline === 'DarkGray',
    'border border-Black10': _vm.outline === 'Black',

    'h-12px p-0': _vm.size === 12,
    'h-18px': _vm.size === 18,
    'h-20px text-2xs': _vm.size === 20,
    'h-30px px-2 text-xs': _vm.size === 30,
    'h-18px font-light': _vm.size !== 22,
    'px-1.5 py-0.5': _vm.size === 22,
    'h-26px px-1.5 text-lg': _vm.size === 26,
    'h-36px px-1.5 text-xl': _vm.size === 36,
  }},[(_vm.icon)?_c('AppIcon',{staticClass:"mr-1 max-h-full",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }